export function RemoveCloudIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.8618 17.2656H7.60406C7.14773 17.2656 6.54351 17.176 5.93928 16.9309C4.50315 16.278 3.5 14.8341 3.5 13.1527C3.5 10.5588 5.33603 9.04089 7.60406 9.01657V9.00781"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.41016 5.8125L18.4766 19.879"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.22852 5.3529H9.2363C10.004 4.62607 11.0723 4.12109 12.5007 4.12109C14.3124 4.12109 15.5364 4.93646 16.3031 5.95712C17.0786 6.97681 17.3967 8.20083 17.3967 9.01717C19.6648 9.04149 21.5008 10.5594 21.5008 13.1533C21.5008 14.3861 20.9705 15.4875 20.1221 16.2377"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
